export default __webpack_public_path__ + "static/media/bubbles.744ed5fe.JPG";